import React from 'react';
import PropTypes from 'prop-types';
import { EmptyStateContainer, EmptyStateTitle, EmptyStateDescription } from './styles';
const EmptyState = ({ className, icon, title, description, children }) => {
    return (React.createElement(EmptyStateContainer, { className: className },
        icon,
        React.createElement(EmptyStateTitle, null, title),
        React.createElement(EmptyStateDescription, null, description),
        children));
};
EmptyState.defaultProps = {
    className: null,
    icon: null,
    title: null,
    description: null,
    children: null,
};
EmptyState.propTypes = {
    className: PropTypes.string,
    icon: PropTypes.node,
    title: PropTypes.node,
    description: PropTypes.node,
    children: PropTypes.node,
};
export default EmptyState;
//# sourceMappingURL=index.js.map